export default __webpack_public_path__ + "static/media/tng-logo.0a8a3749.svg";